<template>
  <div>
    <b-modal ref="profilesSelector"
             :title="$t('manage.requirements_profiles.open_publics')"
             :ok-title="$t('open')"
             :cancel-title="$t('cancel')"
             :no-enforce-focus="true"
             size="lg"
             centered
             @ok.prevent="">
      <div>
        <!-- Display -->
        <div class="form-group row">
          <label for="toshow" class="col-md-3 col-form-label text-md-right">{{ $t('display') }}</label>
          <div class="col-md-7">
            <select id="toshow" v-model="category" class="custom-select" name="toshow">
              <option v-for="(cat, i) in categories" :value="i">{{ $t('manage.requirements_profiles.categories.' + cat) }}</option>
            </select>
          </div>
        </div>
        <!-- Search -->
        <div class="form-group row">
          <label for="search" class="col-md-3 col-form-label text-md-right">{{ $t('title') }}</label>
          <div class="input-group col-md-7">
            <input id="search" :placeholder="$t('search')" v-model="search.title" type="text" class="form-control" name="search" >
          </div>
        </div>
        <div class="form-group row">
          <label for="author" class="col-md-3 col-form-label text-md-right">{{ $t('author') }}</label>
          <div class="input-group col-md-7">
            <input id="author" :placeholder="$t('search')" v-model="search.author" type="text" class="form-control" name="author" >
          </div>
        </div>
        <div class="form-group row">
          <label for="author" class="col-md-3 col-form-label text-md-right">{{ $t('contact_occupation') }}</label>
          <div class="input-group col-md-7">
            <button id="profileSelectorISCOButton" class="btn btn-primary btn-isco" @click.prevent="showISCO('profileSelectorISCOModal')">{{ $t(search.isco ? search.isco : 'isco_selector.choose_an_occupation') }}</button>
            <button v-if="search.isco" id="profileSelectorISCOReset" class="btn btn-danger btn-isco-reset" @click.prevent="resetISCO()">
              <fa icon="times" />
            </button>
          </div>
        </div>
        <!-- Table -->
        <div class="w-100">
          <table class="table">
            <thead>
              <tr>
                <th>{{ $t('author') }}</th><th>{{ $t('title') }}</th><th>{{ $t('job') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="snapshot in displayedProfiles"
                  :class="{ 'bg-light': selected.id == snapshot.id }"
                  @click="selected = snapshot">
                <td v-if="snapshot.created_by.organization_id == user.organization_id">{{ snapshot.created_by.first_name }} {{ snapshot.created_by.last_name }}</td>
                <td v-else>{{ snapshot.created_by.organizationName }}</td>
                <td>{{ snapshot.title }}</td>
                <td>
                  <template v-if="snapshot.accompanying_sheet">
                    {{ $t(snapshot.accompanying_sheet.isco) }}
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
          <PaginationBlock v-if="searchFiltered" :page-count-steps="pageCountSteps" :length="searchFiltered.length" v-model="page" />

        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <div class="float-right">
          <b-btn variant="secondary" @click="$refs.profilesSelector.hide()">{{ $t('cancel') }}</b-btn>
          <b-btn variant="primary" @click="openSnapshot">{{ $t('open') }}</b-btn>
        </div>
      </div>
    </b-modal>
    <ISCOSelectorModal id="profileSelectorISCOModal" ref="iscoModal" @saved="iscoSaved" @closed="iscoClosed('profileSelectorISCOModal')" />
  </div>
</template>
<style scoped>
.btn-isco, .btn-isco-reset {
  margin-top: 0;
}
.btn-isco {
  margin-right: 10px;
}
</style>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfilesSelector',

  props: {
    profiles: { type: Array, required: true }
  },

  data: () => ({
    categories: ['all', 'organization', 'esap'],
    category: 0,
    search: {},
    selected: -1,
    page: { page: 1, count: 10 },
    pageCountSteps: [10, 25, 50, 100]

  }),

  computed: {
    candidatesProfiles: function () {
      return this.profiles.filter(x => x.accompanying_sheet != null && x.accompanying_sheet.generic_snapshot && x.accompanying_sheet.approved)
    },

    organizationProfiles: function () {
      return this.candidatesProfiles.filter(x => x.created_by.organization_id == this.user.organization_id)
    },

    esapProfiles: function () {
      return this.candidatesProfiles.filter(x => x.accompanying_sheet.shared_with_community && x.created_by.organization_id != this.user.organization_id && x.accompanying_sheet.approved_admin)
    },

    toShow: function () {
      switch (this.category) {
        case 1: return this.organizationProfiles
        case 2: return this.esapProfiles
        default: return this.candidatesProfiles
      }
    },
    searchFiltered: function () {
      // if(this.search.length > 1)
      // {
      //   let searchTerm = this.search.toLowerCase();
      //   return this.toShow.filter(x => x.accompanying_sheet.job.toLowerCase().includes(searchTerm) || x.title.toLowerCase().includes(searchTerm));
      // }

      var search = [
        { 'value': this.search.title, 'fields': ['title', { prop: 'accompanying_sheet', child: 'job' }] },
        { 'value': this.search.author, 'fields': [{ prop: 'created_by', child: 'last_name' }, { prop: 'created_by', child: 'first_name' }] },
        { 'value': this.search.isco, 'fields': [{ prop: 'accompanying_sheet', child: 'isco' }] }
      ]
      return this.searchFilter(this.toShow, search)
      // return this.toShow;
    },
    displayedProfiles () {
      if (this.searchFiltered) {
        const start = (this.page.page - 1) * this.page.count
        const end = start + this.page.count
        return this.searchFiltered.slice(start, end)
      }
      return this.searchFiltered
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {
    hide () {
      this.$refs.profilesSelector.hide()
    },

    show () {
      this.$refs.profilesSelector.show()
    },

    openSnapshot () {
      if (this.selected) { this.$emit('openSnaphot', this.selected) }
      this.hide()
    },

    searchFilter (list, searchTerms) {
      searchTerms.forEach(function (searchTerm) {
        const keys = searchTerm.fields
        if (searchTerm.value && searchTerm.value.length > 1 && list) {
          const term = searchTerm.value.toLowerCase()
          list = list.filter(p => keys.map(k => (typeof k === 'string' || k instanceof String) ? p[k] : (p[k.prop] ? p[k.prop][k.child] : '')).filter(t => t.toLowerCase().search(term) >= 0).length > 0)
        } else if (typeof searchTerm.value === 'boolean') {
          const term = searchTerm.value ? 1 : 0
          list = list.filter(p => keys.map(k => (typeof k === 'string' || k instanceof String) ? p[k] : (p[k.prop] ? p[k.prop][k.child] : '')).filter(t => t == term).length > 0)
        }
      })
      return list
    },
    iscoSaved (occupation) {
      this.$set(this.search, 'isco', occupation)
    },
    iscoClosed (id) {
      $('#profileSelectorISCOModal').modal('show')
    },
    showISCO (id) {
      $('#profileSelectorISCOModal').modal('show')
    },
    resetISCO () {
      this.$set(this.search, 'isco', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ProfilesSelector.vue